import {
  APPOINTMENT_TABLE_HEADERS,
  MY_APPOINTMENT_TABLE_HEADERS,
  getLocationColumnLabel,
} from "./appointmentViewShared";

export default function AppointmentTableHead({
  sticky = false,
  showDoctorColumn = true,
  tokenOnly = false,
  myAppointmentLayout = false,
}: {
  sticky?: boolean;
  showDoctorColumn?: boolean;
  tokenOnly?: boolean;
  myAppointmentLayout?: boolean;
}) {
  const locationLabel = getLocationColumnLabel(tokenOnly);
  const headers = myAppointmentLayout
    ? MY_APPOINTMENT_TABLE_HEADERS
    : showDoctorColumn
      ? APPOINTMENT_TABLE_HEADERS
      : APPOINTMENT_TABLE_HEADERS.filter((col) => col.key !== "doctor");

  return (
    <thead
      className={`bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-700 dark:to-slate-800 border-b-2 border-slate-200 dark:border-slate-600 ${
        sticky ? "sticky top-0 z-10 shadow-sm" : ""
      }`}
    >
      <tr>
        {headers.map((col) => (
          <th
            key={col.key}
            className={`px-4 xl:px-6 py-3.5 text-[11px] font-bold text-slate-600 dark:text-slate-200 uppercase tracking-wider ${
              col.align === "center"
                ? "text-center w-28 xl:w-32"
                : "text-left"
            }`}
          >
            {col.key === "location" ? locationLabel : col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
}
